import React, { useState, useEffect } from 'react';
import '../../styles/Cancion.css';
import axiosPost from '../../helper/axios-helper';

export default function Cancion() {
    const [ currentIssue, setCurrentIssue ] = useState({
        id: 1,
        title: 'ARTIFICIAL INTELLIGENCE',
        image: 'https://ts.canto.org/data/images/CANCION-01.2024-4.jpg',
        summary: "The debut issue of CANCION Magazine, published by CANTO, explores the transformative power of Artificial Intelligence (AI) as a tool for sustainable development across the Caribbean. The futuristic cover art features a powerful visual metaphor—a woman's face seamlessly transitioning into a robotic form—symbolizing the harmonious convergence of humanity and advanced technology. The headline emphasizes AI's potential to reshape industries, improve public services, and create new economic opportunities throughout the region. By focusing on AI within a sustainable development context, this issue positions the Caribbean as a forward-thinking region ready to embrace innovation responsibly. A globe embedded in the magazine's logo reinforces the global relevance of the Caribbean's tech evolution, while the multilingual slogan at the bottom—'Many Nations… One Voice'—underscores CANTO's commitment to inclusivity and regional unity. This message is powerfully echoed in six languages (English, Spanish, Dutch, French, and others), reflecting the region's cultural and linguistic diversity.",
        flipbook_url: ''
    });

    useEffect(() => {
        fetchCurrentIssue();
    }, []);

    const fetchCurrentIssue = () => {
        axiosPost('current_issue/fetch', {}, {}, (data) => {
            const { success, response } = data;

            if (success) {
                setCurrentIssue(data.data);
            } else {
                console.error('Failed to fetch current issue:', response);
            }
        });
    }

    return (
        <div className='Cancion'>
            <div className='CancionCover' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/cancion_cover.png'})`}}>
                <div className='CancionCoverContent'>
                    CANCION Magazine
                </div>
            </div>

            <div className='CancionContent'>
                <div className='CancionContentMain'>
                    <div className='CancionContentMainHeader'>ABOUT CANCION</div>
                    <div className='CancionContentMainTitle'>
                        CANCION: Telling the Story of Caribbean ICT for Over 30 Years                    
                    </div>
                    <div className='CancionContentMainText'>
                        CANCION is the Caribbean’s only telecommunications-focused magazine- a digital publication produced by CANTO, rooted in the region and created for those shaping the future of ICT in the Caribbean and Latin America. <br/> <br/>
                    </div>
                    <div className='CancionContentMainText'>
                        Since 1992, CANCION has provided an essential platform for insight, commentary, and coverage of the telecommunications and ICT sectors. From regulatory developments and digital transformation to innovation, policy, and infrastructure — CANCION explores the issues that matter most to the industry and the people driving its progress. <br/> <br/>
                    </div>
                    <div className='CancionContentMainText'>
                        For over three decades, the quarterly magazine has featured thought leadership, in-depth reporting, and business intelligence, while spotlighting the products, services, and success stories of CANTO’s members and partners. With its broad reach, CANCION enhances visibility for companies across the region, supporting their strategic goals and showcasing their contributions to regional development. <br/> <br/>
                    </div>
                    <div className='CancionContentMainText'>
                        In 2020, the CANCION transitioned from print to a fully digital format, expanding its reach and accessibility through CANTO’s online platforms. <br/> <br/>
                    </div>
                    <div className='CancionContentMainText'>
                        As the industry evolves, so does CANCION — a trusted voice in Caribbean ICT, continuing to inform, connect, and inspire. <br/> <br/>
                    </div>
                </div>
                <div className='CancionContentAlt'>
                    <div className='CancionContentAltContainer'>
                        {/* <div className='CancionContentAltHeader'>Advertising</div> */}
                        <div className='CancionContentAltText'>
                            Contact our Sales & Marketing Officer, Chrisal Martin at <span>cmartin@canto.org</span>
                        </div>
                    </div>

                    <div className='CancionContentAltContainer'>
                        {/* <div className='CancionContentAltHeader'>Submission</div> */}
                        <div className='CancionContentAltText'>
                            Want to submit an article? Reach out to our Business Support Officer, Andrea Lewis-Francis, at <span>alewis@canto.org</span>
                        </div>
                    </div>

                    <div className='CancionContentAltHeader'>Cancion Team:</div>

                    <div className='CancionContentAltContainer'>
                        <div className='CancionContentAltHeader'>Editorial director</div>
                        <div className='CancionContentAltText'>
                            Teresa Wankin <br/>
                            twankin@canto.org
                        </div>
                    </div>
                    <div className='CancionContentAltContainer'>
                        <div className='CancionContentAltHeader'>Editor in Chief</div>
                        <div className='CancionContentAltText'>
                            Lianne Dieffenthaller <br/>
                            ldieffenthaller@canto.org
                        </div>
                    </div>
                    <div className='CancionContentAltContainer'>
                        <div className='CancionContentAltHeader'>Editorial</div>
                        <div className='CancionContentAltText'>
                            Alicia Carter-Fisher <br/>
                            aliciacarterfisher@icloud.com
                        </div>
                    </div>
                    <div className='CancionContentAltContainer'>
                        <div className='CancionContentAltHeader'>Proof Reader</div>
                        <div className='CancionContentAltText'>
                            Andrea Lewis-Francis <br/>
                            alewis@canto.org
                        </div>
                    </div>
                    <div className='CancionContentAltContainer'>
                        <div className='CancionContentAltHeader'>Production & Art Director</div>
                        <div className='CancionContentAltText'>
                            Jenelle Diaz <br/>
                            jdiaz@canto.org
                        </div>
                    </div>
                </div>
            </div>

            <div className='CancionCurrentIssue'>
                <div className='CancionCurrentIssueHeader'>Our Current Issue</div>
                <div className='CancionCurrentIssueContainer'>
                    <div className='CancionCurrentIssueCover' style={{backgroundImage: `url(${currentIssue.image})`}}></div>
                    <div className='CancionCurrentIssueInfo'>
                        <div className='CancionCurrentIssueInfoTitle'>{currentIssue.title}</div>
                        <div className='CancionCurrentIssueInfoSum'>{currentIssue.summary}</div>
                        {currentIssue.flipbook_url && (
                            <a href={currentIssue.flipbook_url} target="_blank" rel="noopener noreferrer" className='CancionCurrentIssueInfoBtn'>
                                READ THE FLIPBOOK
                            </a>
                        )}
                        {!currentIssue.flipbook_url && (
                            <div className='CancionCurrentIssueInfoBtn'>READ THE FLIPBOOK</div>
                        )}
                    </div>
                </div>
            </div>

            <div className='CancionBookshelf'>
                <div className='CancionCurrentIssueHeader'>Previous Issues</div>
                <iframe
                    src="https://player.flipsnack.com?hash=N0RFQkM1OTlFOEMraDllenM1bjd0OQ=="
                    width="100%"
                    height="100%"
                    seamless="seamless"
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; clipboard-read; clipboard-write"
                    title="Flipsnack Embed"
                ></iframe>
            </div>
        </div>
    )
}
